import Highcharts from 'highcharts';
export default async (lang) => {
    const translation = await import(/* webpackChunkName: "lang-[request]" */ `@/locale/${lang}/high-charts`);
    Highcharts.setOptions({
        lang: translation.default,
    });
};
